module.exports = __webpack_public_path__ + "static/media/stocksense.88b2dfea.png";